import React, { Component } from 'react';
import Header from './Header';
import { Footer } from './Footer';
import { NewsletterSignup } from './NewsletterSignup';
import SEO from './SEO';
import 'typeface-open-sans';
import '../sass/global/styles.scss';
import './Layout.scss';

class Layout extends Component {
  render() {
    const { children, seo, isHome, bodyClassName, siteName } = this.props;
    return (
      <>
        {!isHome && <Header />}
        <main className="main-content">
          <SEO {...seo} bodyClassName={bodyClassName} />
          {children}
        </main>
        <div className="reveal">
          <NewsletterSignup />
          <Footer siteName={siteName} />
        </div>
      </>
    );
  }
}

export default Layout;
